import type { ReactNode } from "react";

type FormPageHeadingProps = {
  title: ReactNode;
  subtitle?: ReactNode;
};

export default function FormPageHeading({
  title,
  subtitle,
}: FormPageHeadingProps) {
  return (
    <div className="mt-12 mb-8 flex w-full flex-col items-center gap-4 text-center">
      <h2
        className="w-full text-center text-xl font-semibold leading-6 text-[#111827]"
        data-replay-safe
      >
        {title}
      </h2>
      {subtitle ? (
        <p
          className="px-[30px] text-xs leading-5 text-[rgb(106,112,129)]"
          data-replay-safe
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
